/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TokenUpdate = {
    properties: {
        expirationMonth: {
            type: 'number',
            isNullable: true,
            format: 'int32',
        },
        expirationYear: {
            type: 'number',
            isNullable: true,
            format: 'int32',
        },
        firstName: {
            type: 'string',
            isNullable: true,
        },
        lastName: {
            type: 'string',
            isNullable: true,
        },
        streetAddress: {
            type: 'string',
            isNullable: true,
        },
        city: {
            type: 'string',
            isNullable: true,
        },
        state: {
            type: 'string',
            isNullable: true,
        },
        zip: {
            type: 'string',
            isNullable: true,
        },
        isSaved: {
            type: 'boolean',
            isNullable: true,
        },
        achType: {
            type: 'ACHTypeEnum',
        },
        achAccountHolderType: {
            type: 'ACHAccountHolderTypeEnum',
        },
    },
};